import Curl from '$common/utils/curl/browser-curl';
import UrlModules from '$common/utils/curl/browser-curl/url-modules';
import AppCurl from '$common/utils/curl/app-curl';

export const gatewayWeb = 'gateway_web';
export const fileWeb = 'file_web';

const appgatewayHost = new UrlModules({ module: 'appgateway' });
const defaultCurl = (params, url, config) => new Curl().curl(params, `${appgatewayHost.host}/${gatewayWeb}/${url}`, config);
const defaultAppCurl = (params, url, config) => new AppCurl().curl(params, `/${url}`, config);

//  封装统一的请求
export const curlGateWay = (params, url, config) => ($vm?.$root?.isWownowApp) ? defaultAppCurl(params, url, config) : defaultCurl(params, url, config);

/**
 * 门店信息
 */
export const getStoreInfo = (params, config) => defaultCurl(params, `digitalMenu/api/store/get-store-info`, config)

/**
 * 获取桌台名
 */
export const getTableName = (params, config) => defaultCurl(params, `digitalMenu/api/store/getTableName`, config)

/**
 * 获取菜单列表
 */
export const getMenuList = (params, config) => defaultCurl(params, `digitalMenu/api/menu/get-menu-list`, config)

/**
 * 获取商品列表
 */
export const getProductList = (params, config) => defaultCurl(params, `digitalMenu/api/product/get-product-list`, config)

/**
 * 创建订单
 */
export const createOrder = (params, config) => curlGateWay(params, `digitalMenu/api/order/create-order`, config)

/**
 * 获取订单详情
 */
export const getOrderDetail = (params, config) => curlGateWay(params, `digitalMenu/api/order/get-order-detail`, config)

/**
 * 获取订单列表
 */
export const getOrderList = (params, config) => curlGateWay(params, `digitalMenu/api/order/get-order-list-api`, config)

/**
 * 当前用户是否存在未支付订单
 * @param params
 * @param config
 */
export const currentUserExistUnpaidOrder = (params, config) => curlGateWay(params, 'digitalMenu/api/order/query-unpay-order-api', config);
